import { classifyError, ERROR_KIND } from './classifyError';
import { getNotifier } from './notifyUser';

const toastVariantForKind = (kind) => {
  if (kind === ERROR_KIND.NETWORK) return 'network';
  if (kind === ERROR_KIND.AUTH) return 'warning';
  return 'error';
};

const notifyActionErrorToast = (error, { title, message, onRetry, operation = 'mutation' } = {}) => {
  const classified = classifyError(error, { operation });

  getNotifier().toast({
    type: toastVariantForKind(classified.kind),
    title: title || classified.title,
    message: message || classified.message,
    duration: 6000,
    actionLabel: onRetry ? 'Erneut versuchen' : undefined,
    onAction: onRetry,
  });
};

export const notifySaveError = (error, { title = 'Speichern fehlgeschlagen', message, onRetry } = {}) => {
  notifyActionErrorToast(error, { title, message, onRetry });
};

export const notifyDeleteError = (error, { onRetry } = {}) => {
  const classified = classifyError(error, { operation: 'mutation' });

  notifyActionErrorToast(error, {
    title: 'Löschen fehlgeschlagen',
    message: error?.message || classified.message || 'Der Eintrag konnte nicht gelöscht werden. Bitte versuche es erneut.',
    onRetry,
  });
};

export const notifyValidationToast = (message, title = 'Eingabe prüfen') => {
  getNotifier().toast({
    type: 'info',
    title,
    message,
    duration: 5000,
  });
};

export const notifyErrorToast = (message, { title = 'Ein Fehler ist aufgetreten', onRetry } = {}) => {
  getNotifier().toast({
    type: 'error',
    title,
    message,
    duration: 6000,
    actionLabel: onRetry ? 'Erneut versuchen' : undefined,
    onAction: onRetry,
  });
};

export const notifyBlockedToast = (message, title = 'Nicht möglich') => {
  getNotifier().toast({
    type: 'info',
    title,
    message,
    duration: 5000,
  });
};

export const notifySuccessToast = (message, title = '') => {
  getNotifier().success(message, title);
};

export const SKIP_GLOBAL_ERROR = { context: { skipGlobalError: true } };
